import { useGetAllUserPlantsApi } from '../../infrastructure/api/usePlantSelectApi'

export const useGetAllUserPlantsUseCase = () => {
  const { getAllUserPlants } = useGetAllUserPlantsApi()
  return {
    getAllUserPlants: async () => {
      return getAllUserPlants()
    },
  }
}
